import React, { createContext, useState, useEffect, useMemo} from "react";
import TagDinamicaService from "../services/TagDinamicaService";
import { cachearContexto } from '../helpers/CachearContexto';
import caAPI from "../services/caAPI";

export const TagDinamicaContext = createContext({});

export function TagDinamicaProvider({ children }) {
  const [tagDinamicaLista, setTagDinamicaLista] = useState([]);
  const [mapTagDinamicaLista, setMapTagDinamicaLista] = useState({});

  useEffect(()=>{ 
    if(caAPI.getLocalState('token')) {
      cachearContexto(tagDinamicaLista, setTagDinamicaLista, TagDinamicaService.index);
    }
  }, []);

  useEffect(()=>{
    if(!!tagDinamicaLista?.length){
      setMapTagDinamicaLista(Object.fromEntries(tagDinamicaLista?.map(item => [item.tag, item])));
    }
  },[tagDinamicaLista])

  const checarPossuiTagsDinamicas = (mensagem)=>{
    let possuiTag = false;
    for(const tag of tagDinamicaLista){
      if(mensagem.includes(`[[${tag?.tag}]]` || `{{${tag?.tag}}}`)){
        possuiTag = true;
        break;
      }
    }
    return possuiTag;
  }

  const values = useMemo(()=>{
    return {
      tagDinamicaLista,
      checarPossuiTagsDinamicas,
      mapTagDinamicaLista
    }
  },[tagDinamicaLista, mapTagDinamicaLista])

  return (
    <TagDinamicaContext.Provider value={values}>
      {children}
    </TagDinamicaContext.Provider>
  )
}
